import styled from "styled-components";
import { useState, useContext, useEffect, useRef } from "react";
import { max } from "date-fns";

const SliderWrapper = styled.div<{ $color: string; $percentage: number }>`
  --in-person: #e4f12c;
  --by-text: #92c92c;
  width: 100%;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  input {
    min-width: 95%;
    appearance: none;
    background: transparent;
    cursor: pointer;
  }
  input::-webkit-slider-runnable-track {
    background: linear-gradient(
      to right,
      var(--accent-color-dark) ${(props) => props.$percentage}%,
      var(--by-text) ${(props) => props.$percentage}%
    );
    border-radius: 5px;
    height: 6px;
    width: 100%;
    user-select: none;
  }
  input::-webkit-slider-thumb {
    appearance: none;
    background-color: var(--accent-color-dark);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    transform: translateY(-6px);
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 800px) {
    input::-webkit-slider-thumb {
      width: 23px;
      height: 23px;
      transform: translateY(-9px);
    }
  }
`;

const Visualisation = styled.div`
  min-width: 100%;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  text-align: center;
  .in-person {
    color: var(--accent-color-dark);
    height: 100%;
  }
  .by-text {
    color: var(--by-text);
    height: 100%;
  }
`;

export default function PercentSlider(props: Props) {
  const [percent, setPercent] = useState<number>(0);

  //change value of inPersonHours on % change
  useEffect(() => {
    const inPersonHours = (percent / 100) * props.totalHours;
    props.onChange(inPersonHours);
  }, [props.totalHours, props.inPersonHours]);

  // Set Initial value of percent when receiving value from props
  useEffect(() => {
    if (!props.inPersonHours) return;
      let percentage = (props.inPersonHours * 100) / props.totalHours;
      percentage = Math.round(percentage / 10) * 10;
      setPercent(percentage);
  }, [props.inPersonHours]);

  function changePercent(value: number) {
    setPercent(value);
    const inPersonHours = (value / 100) * props.totalHours;
    props.onChange(inPersonHours);
  }

  return (
    <SliderWrapper $color={props.color} $percentage={percent}>
      <Visualisation>
        <div className="in-person">
          In Person & Calls
          <br />
          {percent}%
        </div>
        <div className="by-text">
          Text & Emails
          <br />
          {100 - percent}%
        </div>
      </Visualisation>

      <input
        type="range"
        min="0"
        max="100"
        value={percent}
        step="10"
        onChange={(e) => changePercent(parseFloat(e.target.value))}
        className="slider"
        id="myRange"
      ></input>
    </SliderWrapper>
  );
}

interface Props {
  inPersonHours: number;
  onChange: (value: number) => void;
  totalHours: number;
  color: string;
}
